import { ButtonShowType, NavEvents, NavHandleEvent } from '@lighthouse/core'

export const data: {
    value: NavHandleEvent
    label: string
    icon: string
    group: string
    disable?: boolean
}[] = [
    { value: NavHandleEvent.OPEN_PAGE, label: '打开页面', icon: 'ArrowSquareIn', group: '打开' },
    { value: NavHandleEvent.OPEN_LINK, label: '打开链接', icon: 'LinkSimple', group: '打开' }
    // { value: 'createRecord', label: '创建记录', icon: 'Add', group: '记录' },
    // { value: 'updateRecord', label: '更新记录', disable: true, icon: 'ArrowCounterClockwise', group: '记录' },
    // { value: 'deleteRecord', label: '删除记录', disable: true, icon: 'Trash', group: '记录' }
]

export const btnTypeList: { value: ButtonShowType; label: string }[] = [
    {
        value: 'name',
        label: '仅文字'
    },
    {
        value: 'icon',
        label: '仅图标'
    },
    {
        value: 'icon-name',
        label: '图标加文字'
    }
]

export const btnStyleList: { value: string; label: string }[] = [
    {
        value: '0',
        label: '主按钮'
    },
    {
        value: '1',
        label: '次级按钮'
    }
]

export const navEventsMap = new Map<NavHandleEvent, NavEvents>([
    [
        NavHandleEvent.OPEN_PAGE,
        {
            handleEvent: NavHandleEvent.OPEN_PAGE,
            params: [''],
            triggerEvent: 'click'
        }
    ],
    [
        NavHandleEvent.OPEN_LINK,
        {
            handleEvent: NavHandleEvent.OPEN_LINK,
            params: [''],
            triggerEvent: 'click'
        }
    ]
])
